import {useEffect, useState} from "react";
import Select from "react-select";

export const TransactionCreditDetailCodeSelect = ({onChange, refresh = false, selected, onRefreshFinish}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [options, setOptions] = useState([
        {
            value: 21,
            label: "Tarik Dana"
        },
        {
            value: 22,
            label: "Lainnya"
        },
    ])
    const [selectedOptions, setSelectedOptions] = useState([])

    useEffect(() => {
        if (selected !== undefined) {
            setSelectedOptions(options.find((e) => e.value === selected))
        }
    }, [selected, options])

    useEffect(() => {
        if (refresh === true) {
            setSelectedOptions([])
            onRefreshFinish()
        }
    }, [refresh])


    const handleOnChange = (newValue) => {
        setSelectedOptions(newValue)
        onChange(newValue)
    }


    return (
        <>
            <Select
                getOptionLabel={(opt) => `${opt.label}`}
                value={selectedOptions}
                getOptionValue={(opt) => `${opt.label}`}
                onChange={(newValue, m) => {
                    handleOnChange(newValue)
                }}
                options={options}
                loadOption={isLoading}
                className="js-example-basic-single col-sm-12"
            />
        </>
    )
}
